import React from 'react';
import moment from 'moment';
import { getShowCount } from '@/pages/opinion/utils';
import { chartAllColors } from '@/pages/opinion/constants';
import randomColor from 'randomcolor';

import EChartCommon, {
  getAxisPointer,
} from '@/pages/opinion/components/EChartCommon';
import { formatTimeXAxisText } from '@/pages/opinion/utils/chart';

type EChartsOptions = echarts.EChartsOption;
export default function EChart({
  timelineType,
  tooltipFormatterFunc,
  xAxisData,
  seriesDataArray,
  loading,
  apiError,
  dateType,
  lineLegendFormatter,
}: any) {
  // 设置图形配置
  const makeupOptions = (appointLegendSelected?: {
    [key: string]: boolean;
  }) => {
    const seriesData: EChartsOptions['series'] = [];
    const legendData: Array<any> = [];
    let legendSelected: any = {};
    seriesDataArray.forEach(
      ({ data, seriesOptions = {}, name }: any, index: number) => {
        const seriesItem: any = {
          data,
          type: 'line' as any,
          name: name,
          ...seriesOptions,
        };
        seriesData.push(seriesItem);
        legendData.push({
          name: name,
          icon: 'circle',
        });
        legendSelected[name] = index < 10;
      },
    );
    legendSelected = appointLegendSelected || legendSelected;
    const lackColorNumber = seriesDataArray.length - chartAllColors.length;
    const colorArray =
      lackColorNumber > 0
        ? [
            ...chartAllColors,
            ...randomColor({
              count: lackColorNumber,
            }),
          ]
        : chartAllColors;
    const opts: EChartsOptions = {
      tooltip: {
        formatter: (param) => tooltipFormatterFunc(param, timelineType),
        position: (pos, params, dom, rect, size) => {
          // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
          const [canvasWidth, canvasHeight] = size.viewSize;
          const [mouseX, mouseY] = pos;
          if (mouseX < canvasWidth / 2) {
            return [mouseX + 10, mouseY / 6];
          }
          return [mouseX - 240, mouseY / 6];
        },
      },
      axisPointer: getAxisPointer((data) => {
        return formatTimeXAxisText(data.value, dateType);
      }),
      legend: {
        data: legendData,
        selected: legendSelected,
        formatter: (name) => {
          if (lineLegendFormatter instanceof Function) {
            return lineLegendFormatter(name);
          }
          return name;
        },
      },
      color: colorArray,
      xAxis: {
        data: xAxisData,
        boundaryGap: false,
        axisLabel: {
          formatter: (value) => formatTimeXAxisText(value, dateType),
        },
      },
      yAxis: {
        axisLabel: {
          formatter: (value: any) => {
            if (timelineType === 'non-negative') {
              return value * 100 + '%';
            } else {
              const data = getShowCount(Math.abs(value)) as string;
              return value >= 0 ? data : `-${data}`;
            }
          },
        },
      },
      series: seriesData,
    };

    return opts;
  };

  return (
    <EChartCommon
      loading={loading}
      options={makeupOptions()}
      empty={xAxisData?.length === 0}
      height={304}
    ></EChartCommon>
  );
}
